export default __webpack_public_path__ + "static/media/HowtoPlasmids_FR.04a53e37.pdf";